import {
  FETCH_MOVIE,
  ONE_MOVIE,
  ONE_GENRE,
  CAST_MOVIE,
} from "../actions/actionType";

const movieState = {
  movies: [],
  oneMovie: {},
  castMovie: [],
  genreMovie: {},
};
function movieReducer(state = movieState, action) {
  switch (action.type) {
    case FETCH_MOVIE:
      return { ...state, movies: action.payload };
    case ONE_MOVIE:
      return { ...state, oneMovie: action.payload };
    case ONE_GENRE:
      return { ...state, genreMovie: action.payload };
    case CAST_MOVIE:
      return { ...state, castMovie: action.payload };
    default:
      return state;
  }
}

export default movieReducer;
